import { createSelector } from 'redux-starter-kit';

const quesionnaresSelector = (state: any) => state.questionnare;

export const questionnareSelectors = {
  getQuestions: createSelector(
    quesionnaresSelector,
    subState => subState.questions
  ),
  getRiskLevel: createSelector(
    quesionnaresSelector,
    subState => subState.answers
  ),
  getUserResponses: createSelector(
    quesionnaresSelector,
    subState => subState.responses
  ),
  isJoinedCustomers: createSelector(
    quesionnaresSelector,
    subState => subState.isJoined
  )
};
